import type {ReactElement} from "react";
import {cloneElement, useState} from "react";
import type {IToolConfig, SpaceTool} from "../../../../modules/space/spaceeditor/logic3d/features/tools/Tools";
import type {Color} from "../../../../../generated/api/base";
import type {IToolButtonProps} from "./ToolButtonV5";
import {SharedToolGroupV5} from "./SharedToolGroupV5";

interface IToolGroupProps {
	readonly tools: {
		[id in SpaceTool]: IToolConfig;
	};
	readonly activeTool: SpaceTool;
	readonly onClick: (id: SpaceTool) => void;
	readonly children: ReactElement<IToolButtonProps>[];
	readonly color?: Color;
}

export const ToolGroupV5 = (props: IToolGroupProps) => {
	const [chosenTool, setChosenTool] = useState<SpaceTool>(props.children[0].props.icon as SpaceTool);

	const subMenuItems = props.children.map((container: React.ReactElement<IToolButtonProps>, index: number) => {
		const onClick = () => {
			container.props.onClick();
			setChosenTool(container.props.icon as SpaceTool);
		};

		return cloneElement(container, {key: `${container.props.icon}${container.props.title}`, onClick: onClick});
	});

	return (
		<SharedToolGroupV5
			tools={props.tools}
			activeTool={props.activeTool}
			chosenTool={chosenTool}
			onClick={props.onClick}
			color={props.color}
		>
			{subMenuItems}
		</SharedToolGroupV5>
	);
};
